export default {"src":"/_next/static/media/logo_segment.5e21cbf0.svg","height":39,"width":140,"blurWidth":0,"blurHeight":0};